import { createContext, useState, useEffect, useContext, useRef } from 'react';
import { checkRoomAccess } from '../api/user';

interface Props {
  children: any;
  roomId: string;
  user?: User;
}

export interface RoomContextType {
  isRoomPrivate: boolean | null;
  privateRoomMessage: string;
  isHostorCohost: boolean;
}

export const RoomContext = createContext<RoomContextType>({
  isRoomPrivate: null,
  privateRoomMessage: '',
  isHostorCohost: false,
});

export function useRoom() {
  return useContext(RoomContext);
}

const RoomContextProvider = (props: Props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isRoomPrivate, setIsRoomPrivate] = useState<boolean | null>(null);
  const [privateRoomMessage, setPrivateRoomMessage] = useState<string>('');
  const [isHostorCohost, setIsHostorCohost] = useState<boolean>(false);

  useEffect(() => {
    if (props.user?.uid) {
      checkRoomAccess(props.roomId, props.user?.uid)
        .then(({ data }) => {
          let message = '';
          if (!data.access) {
            message = data.message;
          }

          setIsRoomPrivate(!data.access);
          setPrivateRoomMessage(message);
          setIsHostorCohost(data.is_host);
        })
        .catch((_error) => {
          console.error('Error while checking room access');
          setIsRoomPrivate(true);
          setPrivateRoomMessage('Error while checking room access');
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      setIsLoading(false);
    }
  }, []);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-dvh">
        <h3 className="text-gradient-pink">Loading....</h3>
      </div>
    );
  }

  if (isRoomPrivate) {
    return (
      <div className="flex items-center justify-center h-dvh flex-col">
        <h3 className="text-white text-[18px]">
          {privateRoomMessage || 'This room is private you can not access it.'}
        </h3>
        <button
          className="gradient-btn text-black w-fit p-2 px-4 rounded-xl cursor-pointer mt-4 text-[16px]"
          onClick={() => {
            if (process.env.REACT_APP_DMDB_DOMAIN) {
              window.location.href = process.env.REACT_APP_DMDB_DOMAIN;
            } else {
              window.location.href = 'http://www.dmdb.com';
            }
          }}
        >
          Home
        </button>
      </div>
    );
  }

  return (
    <RoomContext.Provider
      value={{ isRoomPrivate, privateRoomMessage, isHostorCohost }}
    >
      {props.children}
    </RoomContext.Provider>
  );
};

export default RoomContextProvider;
